import { Icon, IconProps } from "@chakra-ui/react";

export function CircleArrowRightIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 40 40" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 5.83332C12.176 5.83332 5.83335 12.176 5.83335 20C5.83335 27.824 12.176 34.1667 20 34.1667C27.8241 34.1667 34.1667 27.824 34.1667 20C34.1667 12.176 27.8241 5.83332 20 5.83332ZM4.16669 20C4.16669 11.2555 11.2555 4.16666 20 4.16666C28.7445 4.16666 35.8334 11.2555 35.8334 20C35.8334 28.7445 28.7445 35.8333 20 35.8333C11.2555 35.8333 4.16669 28.7445 4.16669 20Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.0774 14.4107C21.4028 14.0853 21.9305 14.0853 22.2559 14.4107L27.2559 19.4107C27.4122 19.567 27.5 19.779 27.5 20C27.5 20.221 27.4122 20.433 27.2559 20.5892L22.2559 25.5892C21.9305 25.9147 21.4028 25.9147 21.0774 25.5892C20.752 25.2638 20.752 24.7362 21.0774 24.4107L24.6548 20.8333L13.3333 20.8333C12.8731 20.8333 12.5 20.4602 12.5 20C12.5 19.5398 12.8731 19.1667 13.3333 19.1667L24.6548 19.1667L21.0774 15.5892C20.752 15.2638 20.752 14.7362 21.0774 14.4107Z"
        fill="currentColor"
      />
    </Icon>
  );
}
